<template>
  <div>
    <h3 class="page-title text-center">HERRAMIENTAS PARA INVESTIGADORES</h3>
    <hr>
    <carousel-3d :height="600"
                 :width="360"
                 :space="376"
                 :controls-visible="true"
                 :controls-prev-html="'&#9698;'"
                 :controls-next-html="'&#9698;'"
                 :display="3"
                 class="herramientas">
      <slide :index="0">
        <b-card
          img-src="../../../static/img/herramientas/orcid.png"
          img-alt="Image"
          tag="article"
          img-top
          class="mb-0">
          <!-- <b-row class="justify-content-center text-center herramientas-logo">
             <b-col><img src="../../assets/orcid.svg" class="logo" alt="Responsive image"/></b-col>
           </b-row>-->
          <!--<p class="card-text text-justify">
            <span class="font-weight-bold">ORCID</span> proporciona una identificadora digital persistente que lo
            distingue de cualquier otro
            investigador y, a través de la integración en flujos de trabajo de investigación clave,
            como la presentación de manuscritos y subvenciones, respalda los vínculos
            automatizados entre usted y sus actividades profesionales asegurando que su trabajo
            sea reconocido. Actualmente varias revistas científicas están exigiendo para la
            publicación de artículos que el investigador tenga creado un ORCID–Id.<br/>
            Según el http://blog.impactstory.org, ORCID puede llegar a ser uno de los avances
            más importantes en la comunicación académica en los últimos diez años.
            <b-button href="https://orcid.org/" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp; <i
              class="fa fa-caret-right boton-header"></i></b-button>
          </p>-->
          <p class="card-text text-justify">
            <span class="font-weight-bold">ORCID</span> proporciona una identificadora digital persistente que lo
            distingue de cualquier otro
            investigador y, a través de la integración en flujos de trabajo de investigación clave,
            como la presentación de manuscritos y subvenciones, respalda los vínculos
            automatizados entre usted y sus actividades profesionales asegurando que su trabajo
            sea reconocido. <br/>
            Según el http://blog.impactstory.org, ORCID puede llegar a ser uno de los avances
            más importantes en la comunicación académica en los últimos diez años.
            <b-button href="https://orcid.org/" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp; <i
              class="fa fa-caret-right boton-header"></i></b-button>
          </p>
        </b-card>
      </slide>
      <slide :index="1">
        <b-card
          img-src="../../../static/img/herramientas/researchgate.png"
          img-alt="Image"
          tag="article"
          img-top
          class="mb-0">
          <!-- <b-row class="justify-content-center text-center herramientas-logo">
             <b-col><img src="../../assets/orcid.svg" class="logo" alt="Responsive image"/></b-col>
           </b-row>-->
          <p class="card-text text-justify">
            <span class="font-weight-bold">ResearchGate</span> es una red social científica para científicos e
            investigadores cuya misión es conectar a
            investigadores y facilitarles compartir y acceder a sus publicaciones, conocimientos y
            experiencia. Permite Compartir tus publicaciones, colaborar con otros investigadores,
            obtener estadísticas y métricas sobre tu perfil y tus publicaciones, Resolver cuestiones
            de forma colaborativa.
            <br/>
            <b-button href="https://www.researchgate.net/" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
              <i
                class="fa fa-caret-right boton-header"></i></b-button>
          </p>
        </b-card>
      </slide>
      <slide :index="2">
        <b-card
          img-src="../../../static/img/herramientas/schoolar.png"
          img-alt="Image"
          tag="article"
          img-top
          class="mb-0">
          <!-- <b-row class="justify-content-center text-center herramientas-logo">
             <b-col><img src="../../assets/orcid.svg" class="logo" alt="Responsive image"/></b-col>
           </b-row>-->
          <p class="card-text text-justify">
            Es muy sencillo crear un perfil en <span class="font-weight-bold">Google Scholar</span>. Una de sus ventajas
            es que
            proporciona estadísticas actualizadas con sus citas, entre ellas el índice H. Puede
            comprobar quién cita sus trabajos y las áreas en las que más impacto consigue.
            El link para crearte una cuenta es el siguiente: Ir a  https://scholar.google.es  y pulsar
            en Iniciar sesión, introduciendo correo y contraseña de su cuenta gmail.
            <br/>
            <b-button href="https://scholar.google.es" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
              <i
                class="fa fa-caret-right boton-header"></i></b-button>
          </p>
        </b-card>
      </slide>
      <slide :index="3">
        <b-card
          img-src="../../../static/img/herramientas/academia.png"
          img-alt="Image"
          tag="article"
          img-top
          class="mb-0">
          <!-- <b-row class="justify-content-center text-center herramientas-logo">
             <b-col><img src="../../assets/orcid.svg" class="logo" alt="Responsive image"/></b-col>
           </b-row>-->
          <p class="card-text text-justify">
            <span class="font-weight-bold">Academia</span> es una plataforma que permite compartir documentos con
            millones de personas en todo el
            mundo de forma gratuita. Un  estudio  publicado en PLoS ONE encontró que los
            artículos cargados en la Academia reciben un aumento del 69% en las citas de más de
            5 años. Puedes crearte una cuenta desde google, Facebook u otro correo.
            <br/>
            <b-button href="https://www.academia.edu/" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
              <i
                class="fa fa-caret-right boton-header"></i></b-button>
          </p>
        </b-card>
      </slide>
    </carousel-3d>

    <b-row class="justify-content-md-center pt-5">
      <b-col md="auto" class="">
        <h3>PROGRAMAS GRATUITOS PARA DETECTAR EL PLAGIO</h3>
        <hr>
      </b-col>
    </b-row>
    <b-row class="programas">
      <carousel-3d :disable3d="true"
                   :height="120"
                   :display="2"
                   :width="560"
                   :space="585"
                   :controls-prev-html="'&#9679;'"
                   :controls-next-html="'&#9679;'"
                   :clickable="false"
                   :controls-visible="true"
                   class="programas-next">
        <slide :index="0">
          <b-row>
            <b-col cols="6">
              <a href="http://plagium.com/" target="_blank"><b-img class="programa-img" src="../../../static/img/herramientas/plagium.png" fluid/></a>
            </b-col>
            <b-col cols="5" class="programa-text">Este sistema analiza textos hasta 5000 caracteres.</b-col>
          </b-row>
        </slide>
        <slide :index="1">
          <b-row>
            <b-col cols="6">
              <a href="https://www.duplichecker.com/" target="_blank"><b-img class="programa-img bg-gray-500" src="../../../static/img/herramientas/duplichecker.png" fluid/></a>
            </b-col>
            <b-col cols="5" class="programa-text lead">El comprobador de plagio DupliChecker para la detección
              gratuita de plagio
              admite hasta mil palabras por búsquedas.
            </b-col>
          </b-row>
        </slide>
        <slide :index="2">
          <b-row>
            <b-col cols="6">
              <a href="https://copyleaks.com/" target="_blank"><b-img class="programa-img" src="../../../static/img/herramientas/copyleaks.png" fluid/></a>
            </b-col>
            <b-col cols="5" class="programa-text">Es una plataforma avanzada para rastrear contenido
              en línea. Permite verificar la autenticidad y la originalidad del contenido.
            </b-col>
          </b-row>
        </slide>
      </carousel-3d>
    </b-row>

    <b-row class="justify-content-md-center pt-5">
      <b-col md="auto" class="">
        <h3>PLATAFORMAS PARA EVALUAR LA CALIDAD DE REVISTAS</h3>
        <hr>
      </b-col>
    </b-row>

    <b-row>
      <carousel-3d
        :width="460"
        :height="530"
        :space="420"
        :disable3d="true"
        :display="3"
        :controls-prev-html="'&#9679;'"
        :controls-next-html="'&#9679;'"
        :clickable="false"
        :controls-visible="true"
        class="programas-revistas">
        <slide :index="0">
          <b-row class="justify-content-md-center">
            <b-col cols="8">
              <b-img class="programa-img" src="../../../static/img/herramientas/miar.png" fluid/>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col class="paragraph-rounded" cols="10">
              <p class="lead text-justify parrafos">MIAR recolecta datos para la identificación y análisis de revistas científicas. Si se
                introduce en la casilla de búsqueda un ISSN, se localizará en qué bases
                de datos está indizada la revista. Además, calculará
                su ICDS (sin contar el Índice de Pervivencia si no forma parte de MIAR).</p>
              <br/>
              <b-button href="http://miar.ub.edu/" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
                <i
                  class="fa fa-caret-right boton-header"></i></b-button>
            </b-col>
          </b-row>
        </slide>
        <slide :index="1">
          <b-row class="justify-content-md-center">
            <b-col cols="8">
              <b-img class="programa-img" src="../../../static/img/herramientas/scimago.png" fluid/>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col class="paragraph-rounded" cols="10">
              <p class="lead text-justify parrafos">El SCImago Journal &amp; Country Rank es un portal de acceso público que incluye
                revistas e indicadores científicos nacionales desarrollados a partir de la información
                contenida en la base de datos Scopus®(Elsevier BV). Estos indicadores se pueden
                usar para evaluar y analizar dominios científicos. Las revistas se pueden agrupar por
                área temática(27 áreas temáticas principales), categoría temática(313 categorías
                temáticas específicas) o por país.</p>
              <br/>
              <b-button href="https://www.scimagojr.com/" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
                <i
                  class="fa fa-caret-right boton-header"></i></b-button>
            </b-col>
          </b-row>
        </slide>
        <slide :index="2">
          <b-row class="justify-content-md-center">
            <b-col cols="8">
              <b-img class="programa-img" src="../../../static/img/herramientas/scopus.png" fluid/>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col class="paragraph-rounded" cols="10">
              <p class="lead text-justify parrafos">CiteScore es una métrica ofrecida por Elsevier de manera gratuita y basada en la
                información de la base de datos Scopus.</p>
              <br/>
              <b-button href="https://www.scopus.com/" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
                <i
                  class="fa fa-caret-right boton-header"></i></b-button>
            </b-col>
          </b-row>
        </slide>
        <slide :index="3">
          <b-row class="justify-content-md-center">
            <b-col cols="8">
              <b-img class="programa-img" src="../../../static/img/herramientas/circ.png" fluid/>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col class="paragraph-rounded" cols="10">
              <p class="lead text-justify parrafos">Según su página oficial su objetivo es clasificar las revistas científicas de Ciencias
                Sociales y Humanas en función de la valoración recibidas en los productos de
                evaluación existentes. Evalúa las revistas en 5 grupos los cuales son: Excelencia A + ,
                grupo A, B, C y D.</p>
              <br/>
              <b-button href="https://www.clasificacioncirc.es/" target="_blank" class="small boton-header pull-right" size="sm">Sitio oficial&nbsp;
                <i
                  class="fa fa-caret-right boton-header"></i></b-button>
            </b-col>
          </b-row>
        </slide>

      </carousel-3d>
    </b-row>
  </div>
</template>

<script>
  import {Carousel3d, Slide} from 'vue-carousel-3d'

  export default {
    name: "quienesSomos",
    components: {
      Carousel3d,
      Slide
    },
    data() {
      return {
        slides: 7
      }
    },
  }
</script>

<style scoped>
  .herramientas > .carousel-3d-slide {
    /*width: 275px !important;*/
  }

  .logo {
    width: 25%;
    vertical-align: middle;
    margin-left: auto;
    margin-right: auto;
  }

  .herramientas-parrafo {
    /*    margin-right: 1%;
        margin-left: 1%;*/
  }

  .herramientas-logo {
    margin-top: 5%;
    margin-bottom: 25%;
    background-color: #D5D9DE;
  }

  .carousel-3d-slide {
    border-radius: 25px;
    background-color: #D5D9DE;
    background-color: rgba(240, 244, 249, 0.71);
    border-width: 0px !important;
  }

  .carousel-3d-controls {
    position: absolute;
    top: 50%;
    height: 0;
    margin-top: -30px;
    left: -14px !important;
    width: 100%;
    z-index: 1000;
  }

  .herramientas > .carousel-3d-slide img :not(.logo) {
    height: 30% !important;
  }

  .card {
    background-color: rgba(240, 244, 249, 0.71);
    border-style: hidden;
  }

  .right-1, .left-1, .left-2 {
    top: 0px !important;
  }

  .herramientas > .icon::before {
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }

  /*  .prev::before {
      font-family: FontAwesome;
      font-weight: 900;
      content: "'\f007'" !important;
    }*/

  .herramientas > .card-body {
    padding-top: 0px;
  }

  .card-body > p {
    padding-bottom: 2px;
  }

  p, h1, h2 {
    font-family: MarkBook-Bold;
  }

/*  h1, h2 {
    color: #1E3375;
    font-weight: bold;
  }*/

  .label-rounded {
    background-color: #F7F7F9;
    border-radius: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
    margin-top: 45px;
  }

  .programa-img {
    margin-top: 15%;
    margin-left: 5%;
  }

  .programa-text {
    border-color: #1E3375;
    border-left-style: solid;
    margin-top: 2%;
    margin-bottom: -2%;
    border-left-width: 8px;
    margin-left: 10px;
    color: #1E3375;
    font-size: 10pt;
  }

  .programas > .carousel-3d-container {
    padding-right: 35%;
  }

  .programas-revistas >.carousel-3d-slider> .carousel-3d-slide {
    border-radius: 0px;
    background-color: transparent;
    border-width: inherit;
  }
  .programas-revistas > programa-img{
    border-radius: 23px;
  }
  .paragraph-rounded {
    background-color: #F7F7F9;
    border-radius: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/views/frontend/herramientas.vue